import {
  FormQuestionDto,
  QuestionComponentType,
  QuestionConditionDto,
  QuestionConditionEnum,
} from "@green0meter/api-client";
import { FieldValues } from "react-hook-form";

export const isQuestionConditionMet = (
  condition: QuestionConditionDto,
  allAnswers: FieldValues,
  targetQuestion: FormQuestionDto,
): boolean => {
  const rawAnswerValue = allAnswers[targetQuestion.code];

  if (rawAnswerValue == null) {
    // For NotEquals, no answer means the condition IS met (empty != something)
    return condition.condition === QuestionConditionEnum.NotEquals;
  }

  let answers = Array.isArray(rawAnswerValue) ? rawAnswerValue : [rawAnswerValue];

  if (
    (targetQuestion.componentType === QuestionComponentType.Radio ||
      targetQuestion.componentType === QuestionComponentType.Checkbox ||
      targetQuestion.componentType === QuestionComponentType.Select) &&
    targetQuestion.answerOptions
  ) {
    answers = targetQuestion.answerOptions
      .filter((opt) => answers.includes(opt.code))
      .map((opt) => opt.code);
  }

  switch (condition.condition) {
    case QuestionConditionEnum.Equals:
      return answers.some((code) => condition.value.includes(code));

    case QuestionConditionEnum.NotEquals:
      return !answers.some((code) => condition.value.includes(code));

    case QuestionConditionEnum.Includes:
      return answers.some((code) => condition.value.some((v) => code.includes(v)));

    case QuestionConditionEnum.Greater: {
      const numericAnswers = answers
        .map((code) => Number(code))
        .filter((n) => !isNaN(n));
      const numericCondition = Number(condition.value[0]);

      return numericAnswers.some((n) => n > numericCondition);
    }

    default:
      return false;
  }
};
